export default "__VITE_ASSET__28771261__"